module.exports = __webpack_public_path__ + "static/media/skintype_t.3c704a4c.svg";